import { STATE_HAS_SIGNED } from './constants';

const hasSigned = (participant) => (
  participant.state === STATE_HAS_SIGNED
);

export default hasSigned;
